"use client";

import { handleButtonTracking } from "@/app/utils/button-tracking";
import { motion } from "motion/react";
import posthog from "posthog-js";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import "../app/css/style.css";
import WaitlistInput from "./WaitlistInput";
import Image from "next/image";
import Link from "next/link";
import React from "react";

export default function Hero() {
  const words = "Internal SMS in 5 mins. Skip the red tape.".split(" ");
  const [videoPlayed, setVideoPlayed] = useState(false);

  return (
    <header>
      <div className={`mx-auto px-12 relative flex justify-center lg:h-screen`}>
        <div className="relative w-full flex flex-col lg:flex-row justify-evenly lg:justify-between items-center pt-28 lg:pt-0 gap-x-20">
          <div className="lg:min-w-[590px] max-w-[590px] lg:ml-auto lg:h-full lg:flex lg:flex-col lg:justify-center lg:items-center">
            <div className="w-full mx-auto text-center lg:text-left pb-2"></div>
            <div className="flex flex-col items-center lg:items-baseline w-full text-center">
              <h1
                className={`text-white h1 max-w-3xl mb-4 text-center lg:text-left font-bold tracking-tight leading- lg:leading-tight`}
              >
                <span className="lg:text-6xl text-5xl mb-12">
                  {words.map((word, index) => {
                    const isLastWords = index >= words.length - 4;

                    return (
                      <React.Fragment key={index}>
                        <motion.span
                          initial={{ y: 20, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          transition={{
                            type: "spring",
                            stiffness: 100,
                            damping: 10,
                            delay: index * 0.085,
                          }}
                          style={{
                            willChange: isMobile
                              ? "none"
                              : "transform, opacity",
                          }}
                          className={`inline-block ${isLastWords ? "text-red-300" : "text-white"}`}
                        >
                          {word}
                        </motion.span>
                        {index !== words.length - 1 && " "}
                      </React.Fragment>
                    );
                  })}
                </span>
              </h1>
              <motion.h2
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 10,
                  duration: 0.25,
                  delay: 0.25,
                }}
                style={{
                  willChange: isMobile ? "none" : "transform, opacity",
                }}
                className="max-w-3xl text-lg xl:text-xl text-gray-200 text-center lg:text-left mb-8"
              >
                Discover our solution for small technical teams. Bridge the gap
                between your backend and your team with a single API request for
                instant internal alerts.
              </motion.h2>
              <motion.div
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 10,
                  duration: 0.25,
                  delay: 0.25,
                }}
                style={{
                  willChange: isMobile ? "none" : "transform, opacity",
                }}
              ></motion.div>
              <motion.div
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 10,
                  duration: 0.25,
                  delay: 0.4,
                }}
                style={{
                  willChange: isMobile ? "none" : "transform, opacity",
                }}
                className="w-full mx-auto flex flex-col justify-baseline items-center lg:items-baseline gap-y-3"
              >
                <div className="flex flex-col lg:flex-row flex-wrap justify-center lg:justify-start items-center w-full overflow-hidden gap-y-6 lg:gap-y-6 gap-x-0 lg:gap-x-6 overflow-visible mb-10 lg:mb-0">
                  <WaitlistInput />
                </div>
              </motion.div>
            </div>
          </div>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: "spring",
              stiffness: 100,
              damping: 10,
              duration: 0.25,
              delay: 0.55,
            }}
            style={{
              willChange: isMobile ? "none" : "transform, opacity",
            }}
            className="overflow-visible flex flex-col justify-center items-center w-full lg:w-[650px] h-full mt-6 lg:mt-0 lg:pb-0 mr-auto"
          >
            <div className="w-full relative">
              <div className="absolute -inset-20 -z-10 pointer-events-none">
                <div className="absolute -top-0 -left-0 w-32 h-32 lg:w-64 lg:h-64 bg-blue-300 rounded-full opacity-30 blur-3xl" />
                <div className="absolute -bottom-0 -right-0 w-48 h-48 lg:w-72 lg:h-72 bg-purple-300 rounded-full opacity-25 blur-3xl" />
                <div className="absolute top-0 -translate-y-0 right-0 w-32 h-32 lg:w-56 lg:h-56 bg-indigo-300 rounded-full opacity-20 blur-3xl" />
              </div>

              <div className="rounded-box overflow-hidden shadow-md border border-4 border-blue-200 bg-blue-50 lg:p-2 backdrop-blur-lg relative z-10">
                <Link
                  href="/images/product/notifyapi-example.webp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    src="/images/product/notifyapi-example.webp"
                    width={1920}
                    height={1080}
                    alt="NotifyAPI example"
                    className="cursor-zoom-in"
                  />
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </header>
  );
}
